import { render, staticRenderFns } from "./Trackers.vue?vue&type=template&id=07bc21ac&scoped=true&"
import script from "./Trackers.vue?vue&type=script&setup=true&lang=js&"
export * from "./Trackers.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc21ac",
  null
  
)

export default component.exports